<script setup lang="ts">
import { computed } from 'vue';

export type BadgeColor =
  | 'primary'
  | 'info'
  | 'danger'
  | 'success'
  | 'warning'
  | 'tertiary';

export interface Props {
  color?: BadgeColor;
}
const props = withDefaults(defineProps<Props>(), {
  color: 'primary',
});

const varColorClass = computed(() => 'var-color-' + props.color);
</script>

<template>
  <v-badge
    :class="$style.kBadge"
    data-testid="kBadge"
    :color="$style[varColorClass]"
  >
    <slot></slot>
  </v-badge>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

:export {
  var-color-primary: colors.$color-brand-800;
  var-color-success: colors.$color-green-800;
  var-color-danger: colors.$color-red-800;
  var-color-warning: colors.$color-yellow-500;
  var-color-info: colors.$color-brand-400;
  var-color-tertiary: colors.$color-text-tertiary;
}

.kBadge {
}
</style>
